import {Component, Input} from '@angular/core';
import {Asset, AssetSaleInfo} from '../../shared/domain/item';

@Component({
  selector: 'lib-item-summary-item-sold-info',
  templateUrl: './item-sold-info.component.html'
})
export class ItemSoldInfoComponent {
  @Input() asset: Asset;
  @Input() assetSaleInfo: AssetSaleInfo;
}
